import { FC } from 'react';

import { ReactComponent as BadSmileIcon } from 'icons/BadSmile.svg';
import { ReactComponent as CheckIcon } from 'icons/Check.svg';

import styles from './PassStatusStubPage.module.css';

type Props = {
  isError: boolean;
  title: string;
  subTitle: string;
};

export const Stub: FC<Props> = ({ isError, subTitle, title }) => {
  return (
    <div className={styles.root}>
      <div className={styles.iconBlock}>
        {!isError && <CheckIcon />}
        {isError && <BadSmileIcon />}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.subTitle}>{subTitle}</div>

      <div className={styles.footer}>
        <a className={styles.buttonLink} href="tel:+74959741020">
          Звонок
        </a>
        <a className={styles.buttonLink} target="_blank" href="mailto:vsadmin@villagio-service.ru" rel="noreferrer">
          Почта
        </a>
      </div>
    </div>
  );
};
